module.exports = __webpack_public_path__ + "img/Rectangle_right.9461dd43.svg";